import UpcomingSick from './UpcomingSick';

export default UpcomingSick;
